/** A bundled geo render asset is missing or malformed. The globe cannot be drawn: fail loudly. */
export class GeoAssetError extends Error {
  override readonly name = 'GeoAssetError'
}
